export default __webpack_public_path__ + "static/media/2d.9c1e90ba.png";